import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { getCachedTileUrl } from '../../../helpers/mapTileCaching';
/**
 * Custom Tile Layer that loads tiles from IndexedDB cache first,
 * then falls back to network if not cached.
 */
const OfflineTileLayer = ({ attribution, url }) => {
    const map = useMap();
    useEffect(() => {
        // Create a custom tile layer that checks IndexedDB first
        const CustomTileLayer = L.TileLayer.extend({
            createTile: function (coords, done) {
                const tile = document.createElement('img');
                // Parse tile coordinates
                const tileCoords = {
                    z: coords.z,
                    x: coords.x,
                    y: coords.y,
                };
                // Try to load from cache first
                getCachedTileUrl(tileCoords)
                    .then((cachedUrl) => {
                    if (cachedUrl) {
                        // Use cached tile
                        tile.src = cachedUrl;
                        done(undefined, tile);
                    }
                    else {
                        // Fall back to network
                        const networkUrl = this.getTileUrl(coords);
                        tile.src = networkUrl;
                        done(undefined, tile);
                    }
                })
                    .catch(() => {
                    // On error, fall back to network
                    const networkUrl = this.getTileUrl(coords);
                    tile.src = networkUrl;
                    done(undefined, tile);
                });
                return tile;
            },
        });
        const tileLayer = new CustomTileLayer(url, {
            attribution,
            maxZoom: 19,
            subdomains: ['a', 'b', 'c'],
        });
        tileLayer.addTo(map);
        // Cleanup
        return () => {
            map.removeLayer(tileLayer);
        };
    }, [map, url, attribution]);
    return null;
};
export default OfflineTileLayer;
